import React, { useState } from 'react';
import PopoverFilter from './shared/PopoverFilter/PopoverFilter';
import LoaFilter from './LoaFilter';
import DraughtFilter from './DraughtFilter';
import ClearanceFilter from './ClearanceFilter';
import WidthFilter from './WidthFilter';
import { FormattedMessage, useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { parse } from '../../../util/urlHelpers';
import { InlineTextButton } from '../../Button/Button';
import IconArrowHead from '../../IconArrowHead/IconArrowHead';

import css from './LengthFilter.module.css';

const lengthKeys = ['pub_length', 'pub_clearance', 'pub_draughtNumber', 'pub_beamNumber'];

const LengthFilter = props => {
  const intl = useIntl();
  const history = useHistory();
  const { location } = history;
  const [dimensionsExpanded, setDimensionsExpanded] = useState(false);

  const currentQueryParams = parse(location?.search);
  const hasLength = lengthKeys.some(key => key in currentQueryParams);

  return (
    <PopoverFilter
      label={`${intl.formatMessage({ id: 'ListingFacts.label.length' })}${hasLength ? ' (1)' : ''}`}
      {...props}
    >
      <div className={css.root}>
        <LoaFilter showTrigger={false} />
        <div className={css.divider} />
        <div>
          <InlineTextButton
            className={css.triggerButton}
            onClick={() => setDimensionsExpanded(prev => !prev)}
          >
            <FormattedMessage id="LengthFilter.moreDimensions" />
            <IconArrowHead direction={dimensionsExpanded ? 'up' : 'down'} />
          </InlineTextButton>
        </div>

        {dimensionsExpanded && (
          <div className={css.otherDimensions}>
            <WidthFilter className={css.filter} />
            <DraughtFilter className={css.filter} />
            <ClearanceFilter className={css.filter} />
          </div>
        )}
      </div>
    </PopoverFilter>
  );
};

export default LengthFilter;
